import { createContext } from 'react';

import type SmsService from 'services/sms/smsService';
import { SmsServiceImpl } from 'services/sms/smsServiceImpl';

export const SmsServiceContext = createContext<SmsService>(new SmsServiceImpl());
